export default __webpack_public_path__ + "static/media/RunHorseLight_1_4.f412750f.jpg";